import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_132: DocMigration = {
  maxSchemaVersion: "0.0.132",
  description: "Ensure that any orphaned grouped entities are removed",
  apply(json: any, warnings: string[]) {
    for (const hash in json.entityGroups) {
      const groupId = json.entityGroups[hash];

      if (!json.groups[groupId]) {
        warnings.push(`Entity w/ hash ${hash} has been orphaned from removed group w/ id ${groupId}`);
        delete json.entityGroups[hash];
      }
    }

    return json;
  },
};

export default migration_0_0_132;
